import styles from "./styles.module.scss";
import { Header } from "./Header";
import { ExecutiveSummary } from "../../../../components/ExecutiveSummary/index";

export const Widgets = () => {
  return (
    <div className={styles.dashboard}>
      <Header />
      <ExecutiveSummary showWhatIf={false} hideSwitch />
    </div>
  );
};
